import { supabase } from 'config/supabaseConfig';
import React, { useState } from 'react';
import { useGetUserQuery } from 'components/profile/userSlice';

const VideoCv = ({ userDetails, setRefetch }: any) => {
  const [fileUrl, setFileUrl] = useState('');
  const { data: userData } = useGetUserQuery();

  const user_id = userData?._id;

  async function submitFn() {
    const { error } = await supabase
      .from('fiib_users')
      .update({ video_cv: fileUrl })
      .match({ user_id });
    setRefetch((pre: any) => !pre);
    console.log(error);
  }

  return (
    <div className='p-6 bg-white shadow-lg rounded-lg border border-gray-200'>
      {userDetails.video_cv ? (
        <div className='space-y-4'>
          <a
            className='text-primary font-semibold underline hover:text-primary-dark transition'
            href={userDetails.video_cv}
            target='_blank'
            rel='noreferrer'
          >
            🎥 View Video CV
          </a>
          {userDetails.video_cv_feedback && (
            <div className='p-4 bg-gray-100 rounded-lg border border-gray-300'>
              <h3 className='font-semibold text-gray-700'>Feedback</h3>
              <p className='text-gray-600 mt-2'>
                {userDetails.video_cv_feedback}
              </p>
            </div>
          )}
        </div>
      ) : (
        <div className='space-y-4 text-center'>
          <label className='block text-gray-700 font-medium'>
            Enter Video CV Google Drive Link
          </label>
          <input
            type='text'
            value={fileUrl}
            onChange={(e) => setFileUrl(e.target.value)}
            className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary'
            placeholder='Paste your link here...'
          />
          {fileUrl && (
            <button
              onClick={submitFn}
              className='mt-3 px-6 py-2 bg-primary text-white font-medium rounded-lg hover:bg-primary-dark transition'
            >
              Submit Video CV
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default VideoCv;
